/* eslint-disable deprecation/deprecation */
import { FC } from "react";
import { TopAppLoaderErrors } from "../../common-loader/components/TopAppLoaderErrors";
import { TopAppMessage } from "../../common/components/TopAppMessage";
import { t } from "../../common/miscellaneous/t";
import { useLoaderContextA } from "../hooks/useLoaderContextA";
import { translationsFailedToLoad } from "../miscellaneous/translationsFromPhrases";

export const AppErrors: FC = () => {
  const loaderContext = useLoaderContextA();

  if (t(translationsFailedToLoad) !== translationsFailedToLoad) {
    return null;
  } else {
    return loaderContext !== null && loaderContext.loader.tag === "errors" ? (
      <TopAppMessage title="The Website Failed to Load">
        <TopAppLoaderErrors loader={loaderContext.loader} />
      </TopAppMessage>
    ) : null;
  }
};
